<script>
import InlineAlerts from 'firepuma-vue-axios-vuex-extensions/vuex-errors/components/InlineAlerts.vue';
import LayerBatchChooser from '@/layer/components/LayerBatchChooser.vue';
import AddPackingRecord from '@/layer/components/AddPackingRecord.vue'

export default {
  components: {
    InlineAlerts,
    LayerBatchChooser,
    AddPackingRecord,
  },

  data: () => ({
    batchName: '',
    inlineAlerts: [],
    triggerSelectNextBatch: 0,
  }),

  methods: {
    onPackingRecordAdded(payload) {
      this.triggerSelectNextBatch++;
      this.inlineAlerts.push({ html: `Packing record ${payload.usedDate} was successfully added to batch ${payload.batch.name}.<br><br><strong>Next batch automatically selected.</strong>`, variant: 'success' })
    }
  },
}
</script>

<template>
  <div>

    <div class="mt-3"></div>

    <b-card>
      <h4 class="text-center mt-0">Add Packing Record</h4>

      <layer-batch-chooser v-model="batchName" mode="packing" :trigger-select-next="triggerSelectNextBatch" required />
    </b-card>

    <inline-alerts v-model="inlineAlerts" alert-css-classes="mt-2" />

    <div class="mt-3"></div>

    <api-loader
      v-if="batchName"
      :key="batchName"
      method="get"
      :url="`v1/layers/batches/${encodeURIComponent(batchName)}`"
      @loaded="batch=$event"
      v-slot="{busy, result}">

      <transition name="fade">
        <add-packing-record
          v-if="!busy && result"
          :key="batchName"
          :batch="result"
          @added="onPackingRecordAdded" />
      </transition>

    </api-loader>

  </div>
</template>



// WEBPACK FOOTER //
// src/layer/views/AddPackingRecordView.vue